import React, { Fragment } from "react";
import { BiPlus } from "react-icons/bi";
import { FiMinus } from "react-icons/fi";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
// import { NavLink } from "react-router-dom";
const AllFaq = (props) => {
  return (
    <Fragment>
      <section className="freFrequently_asked">
        <div className="container">
          <h2>{props.mainHeading}</h2>

          <div className="freFrequently_acordian_wrapper">
            <Accordion preExpanded={[0]}>
              {props.detailFaq.map((value, index) => (
                <AccordionItem uuid={index}>
                  <AccordionItemHeading>
                    <AccordionItemButton>
                      <span>
                        <BiPlus className="auto_show" />
                        <FiMinus className="after_show" />

                        {value.faq}
                      </span>
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                    <p>{value.faqAns}</p>
                  </AccordionItemPanel>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </section>
    </Fragment>
  );
};

export default AllFaq;
